export const expression = /[0-9]/g;

export default (value: string): string => value.replace(expression, '');
